<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const emits = defineEmits(['onPrimaryAction', 'onCancel', 'onSecondaryAction', 'onToggleMinimized', 'update:minimized']);

defineProps({
   title: { type: String, default: null },
   cancelText: { type: String, default: null },
   primaryActionText: { type: String, default: null },
   showPreventModal: { type: Boolean, default: false },
   minimizable: { type: Boolean, default: false },
   minimized: { type: Boolean, default: false },
   minimizedTitle: { type: String, default: null },
});

//#region Animation
const open = ref(true);

function cancel() {
   open.value = false;

   setTimeout(() => {
      emits('onCancel');
   }, 300);
}
//#endregion
</script>

<template>
   <Transition name="fade-slide-top" appear>
      <NxtModal
         v-if="open"
         v-bind="$attrs"
         :title="title"
         :cancel-text="cancelText || t('actions.cancel', 2)"
         :primary-action-text="primaryActionText"
         :show-prevent-modal="showPreventModal"
         :prevent-modal-data="{
            title: t('generic.feedback.unsaved-changes'),
            cancelText: t('actions.continue-editing', 2),
            discardText: t('actions.dont-save', 2),
         }"
         :minimizable="minimizable"
         :minimized="minimized"
         :minimized-title="minimizedTitle"
         :max-width="'99vw'"
         @on-cancel="cancel"
         @on-primary-action="emits('onPrimaryAction')"
         @on-secondary-action="emits('onSecondaryAction')"
         @update:minimized="emits('update:minimized', $event)"
      >
         <template v-for="(_, slot) of $slots" #[slot]="scope"><slot :name="slot" v-bind="scope" /></template>
      </NxtModal>
   </Transition>
</template>
